import { render, staticRenderFns } from "./PreviousNextNavigation.vue?vue&type=template&id=adff01ae&scoped=true&"
import script from "./PreviousNextNavigation.vue?vue&type=script&lang=js&"
export * from "./PreviousNextNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PreviousNextNavigation.vue?vue&type=style&index=0&id=adff01ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adff01ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
